import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

/**
 * for this page
 */
import Table from './table';

class TableBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {};

    render() {
        const { isOpen } = this.props;
        const { tit, data, url } = this.props.content;

        return (
            <div className={styles.box}>
                {Object.keys(tit).map((key, index) => {
                    if (data) {
                        return (
                            <Table
                                key={index}
                                content={{
                                    tit: tit[key],
                                    data: data[key],
                                    url: url[index],
                                    idx: index,
                                }}
                                isOpen={isOpen}
                            />
                        );
                    } else {
                        return (
                            <Table
                                key={index}
                                content={{
                                    tit: tit[key],
                                    data: {},
                                    url: url[index],
                                    idx: index,
                                }}
                                isOpen={isOpen}
                            />
                        );
                    }
                })}
            </div>
        );
    }
}

export default errorBoundary(TableBox);
